function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { FieldTypes } from '@sitecore-jss/sitecore-jss-react-forms';

// Overload fieldTypes basic to support custom field definition
// if you want to add new form field add the field name and sitecore Id here
const AddedFieldType = {
  Recaptcha: "{E383BDE2-BC88-4278-83EF-832A15C9E94A}",
  EmailConfirm: "{72B22999-8509-49A1-BD0C-04D68A9131CD}",
  FileUpload: "{7E9A0903-A52C-4843-BBE1-5B26BD162BED}",
  PhoneWithCountrySelection: "{3482B89B-0150-4702-9A00-0A9B899BE4E6}",
  TabList: "{8A0634E9-45D8-458F-B469-A8CFD58EF857}",
  NavigationField: "{5EF02EBD-5A14-4009-83F9-5B0662C571E9}",
  DropdownMultiselect: "{61C22712-B790-43FD-BCB6-154448A65B59}",
  SingleLineTextRegex: "{50BC7E56-4660-4839-8408-1AFC7BC02E5B}",
  Page: "{D819B43E-C136-4392-9393-8BE7FCE32F5E}"
};
const fieldsExtended = _objectSpread(_objectSpread({}, AddedFieldType), FieldTypes);
export default fieldsExtended;